export default __webpack_public_path__ + "static/media/confirmed-check.4d8c9145.svg";